import request from "@/utils/request.js"
// 获取全局配置
export function get_config(data){
  return request({
    	  method:'GET',
    	  url:'/aohua.home/get_page_config',
    	  params:data
    })
}

// 获取导航栏
export function get_nav_list(data){
	return request({
			method:'GET',
			url:'/aohua.home/get_nav_list',
			params:data
	  })
  }